<template>
  <div>
    <loading-overlay :active="Loading" :is-full-page="true" loader="bars" />
    <AgreModal
      :modal="AddModal"
      @cerrarModal="AddModal = false"
      @child-refresh="refrescarCurso = true"
    />
    <VeModal :modal="VerModal" @cerrarModal="VerModal = false" />
    <VideoAdd :modal="AddVideo" @cerrarModal="AddVideo = false" />
    <AddTes :modal="AddTest" @cerrarModal="AddTest = false" />

    <CCard>
      <CCardHeader class="text-center botonesP text-white">
        <b>LISTADO DE CURSOS</b>
      </CCardHeader>
      <CCardBody>
        <CCol sm="12" class="text-right">
          <CButton
            square
            class="botonesP"
            color="dark"
            @click="AddModal = true"
          >
            <CIcon name="cil-playlist-add" />&nbsp; Nuevo curso
          </CButton>
          <CCol class="text-left" sm="12">
            <CDataTable
              :items="items"
              :fields="fieldsCourse"
              :items-per-page="10"
              :noItemsView="tableText.noItemsViewText"
              :table-filter="tableText.tableFilterText"
              :items-per-page-select="tableText.itemsPerPageText"
              hover
              small
              sorter
              pagination
            >
              <template #status="{ item }">
                <td>
                  <CBadge class="text-white" :color="getBadge(item.status)">
                    {{ item.status }}
                  </CBadge>
                </td>
              </template>
              <template #Detalle="{ item }">
                <td class="py-2">
                  <CButton
                    color="dark"
                    class="mr-1"
                    square
                    size="sm"
                    v-c-tooltip="'Editar'"
                    @click="AddModal = item"
                  >
                    <CIcon name="cil-pencil" />
                  </CButton>
                  <CButton
                    shape="square"
                    color="success"
                    size="sm"
                    v-c-tooltip="'Añadir video'"
                    class="mr-1"
                    @click="AddVideo = item"
                  >
                    <CIcon name="cil-plus" />
                  </CButton>
                  <CButton
                    color="dark"
                    square
                    size="sm"
                    class="mr-1"
                    v-c-tooltip="'Ver'"
                    @click="VerModal = item"
                  >
                    <CIcon name="cil-note" />
                  </CButton>

                  <CButton
                    shape="square"
                    color="success"
                    size="sm"
                    v-c-tooltip="'Añadir test'"
                    class="mr-1"
                    @click="AddTest = item"
                  >
                    <CIcon name="cil-plus" />
                  </CButton>
                </td>
              </template>
            </CDataTable>
          </CCol>
        </CCol>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { DateFormater } from "@/_helpers/funciones";
import General from "@/_mixins/general";
import AgreModal from "./add-modal";
import VeModal from "./ver-modal";
import VideoAdd from "./add-VideoModal";
import AddTes from "./add-Test";

import axios from "axios";

const fieldsCourse = [
  {
    key: "id",
    label: "#",
    _style: "width:1%;",
  },
  { key: "CourseName", label: "TITULO",_style:"text-align:left" },
  { key: "daysofvalidity", label: "DIAS DE VIGENCIA", _style:"text-align:left" },
  { key: "price", label: "PRECIO",_style:"text-align:left" },
  { key: "status", label: "ESTATUS",_style:"text-align:left" },
  {
    key: "Detalle",
    label: "ACCIONES",
    sorter: false,
    filter: false,
    _style:"text-align:left"
  },
];

const tableTextHelpers = {
  tableFilterText: {
    label: "FILTRAR:",
    placeholder: "CURSO",
  },
  itemsPerPageText: {
    label: "CURSO POR PAGINA:",
  },
  noItemsViewText: {
    noResults: "NO SE ENCONTRARON RESULTADOS",
    noItems: "NO HAY CURSOS DISPONIBLES",
  },
};

//LISTAR TODOS LOS CURSOS
function ListCurso() {
  let self = this;
  self.Loading = true;
  let listado = [];
  self.items = [];
  axios
    .get(
      this.$apiAdress +
        "/api/courses/all?token=" +
        localStorage.getItem("api_token")
    )
    .then(function (response) {
      listado = response.data;
      self.items = listado.map((listado) =>
        Object.assign({}, self.items, {
          id: listado.id,
          price: "$"+(listado.price),
          daysofvalidity: listado.daysofvalidity,
          status: listado.status,
          CourseName: self.truncateDescription(listado.CourseName,100),
          description: listado.description,
          image: listado.image,
        })
      );
      //console.log(response);
      self.Loading = false;
    })
    .catch(function (error) {
      if (error.response.status == 401) {
        self.Loading = false;
        self.$router.push({ path: "/login" });
        localStorage.clear();
      }
      //console.log(error);
      self.$router.push({ path: "/login" });
    });
}

//DATA
function data() {
  return {
    items: [],
    id: "",
    Loading: false,
    AddModal: false,
    refrescarCurso: false,
    VerModal: false,
    AddVideo: false,
    AddTest: false,

    tableText: Object.assign({}, tableTextHelpers),
  };
}

export default {
  name: "index",
  mixins: [General],
  data: data,
  components: {
    AgreModal,
    VeModal,
    VideoAdd,
    AddTes,
  },
  props: {
    fieldsCourse: {
      type: Array,
      default() {
        return fieldsCourse;
      },
    },
  },
  methods: {
    truncateDescription(text, limit) {
      if (text.length <= limit) {
        return text;
      }
      return text.substring(0, limit) + "...";
    },
    ListCurso,
    getBadge(status) {
      return status === "Activo"
        ? "success"
        : status === "Inactivo"
        ? "danger"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
  },
  watch: {
    refrescarCurso: function () {
      if (this.refrescarCurso) {
        this.ListCurso();
        this.refrescarCurso = false;
      }
    },
  },
  mounted() {
    this.ListCurso();
  },
};
</script>
<style scoped>
svg {
  color: white !important;
}
tr{
  text-align: left !important;
}
</style>
